import { gql } from "@apollo/client"

// Kept out of PTM_MEMBERSHIP_APPLICATIONS_QUERY: a Coach Tools without the
// denial fields rejects the whole document, which would hide every PTM status.
export const MEMBERSHIP_APPLICATION_DENIAL_QUERY = gql`
  query MembershipApplicationDenial($id: ID!) {
    membershipApplication(id: $id) {
      id
      status
      applicationType
      deniedReason
      denialMessage
    }
  }
`
